<template>

    <v-container fluid>
     <v-toolbar color="#FAFAFA" flat>
      <!--v-toolbar-side-icon @click="$emit('showHideMenu')" ></v-toolbar-side-icon-->
        <v-toolbar-title >Compositores</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn color="primary" flat light to="/compositores/adicionar">              
            <v-icon left>add</v-icon>
            Adicionar
        </v-btn>
        
    </v-toolbar>

<v-divider></v-divider>
  <v-card flat>
    <v-card-title>
      
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Busca"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    
    <v-data-table
      :headers="headers"
      :items="composers"
      :search="search"
      no-data-text="Nenhum compositor encontrado."
      no-results-tex="Nenhum resultado encontrado."
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.br_razao_social}}</td>        
        <td class="text-xs-right">
            <v-menu offset-x left bottom>
              <v-btn icon slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile  :to="{name:'compositores_editar', params:{ id:props.item.id} }">
                  <v-list-tile-title>Editar </v-list-tile-title>
                </v-list-tile>                
              </v-list>
            </v-menu>
          </td>
      </template>

      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        A sua busca por "{{ search }}" não teve resultados.
      </v-alert>

    </v-data-table>
  </v-card>

</v-container>     

</template>

<script>
import ComposerService from '../app/Rest/composer'

var composerService = null;

export default {
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Razão Social',
          align: 'left',
          sortable: true,
          value: 'br_razao_social'
        },
        {
          text: 'Ações',
          align: 'right',
          sortable: false,
          value: 'acoes'
        }
      ],
      composers: []
    }
  },
  methods: {
      fetchRecords () {
        //console.log(process.env);
        composerService
          .search({})
          .then(this.fetchRecodsSuccess)
      },
      fetchRecodsSuccess (response) {
        if (Array.isArray(response.items)) {
          this.composers = response.items
          return
        }
        this.rows = []
      }
  },
  created(){
    composerService = ComposerService.build();
  },
  mounted () {
    this.fetchRecords()
  }
}
</script>